import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Nicht vorgerenderte Seiten (z. B. /gastro-spins/...) bekommen per .htaccess-Fallback
// das vorgerenderte HTML der Startseite. Das nicht "hydrieren" (Mismatch, Startseite
// blitzt kurz auf), sondern frisch rendern.
const isPrerenderedPath = !window.location.pathname.startsWith("/gastro-spins");
if (!isPrerenderedPath) rootElement.replaceChildren();

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
